<!-- 热补丁升级 -->
<div *ngIf="iconVisible"
    class="alarm-number"
    [nTooltip]="alarmDropdown"
    nTooltipTrigger="click"
    nTooltipTheme="black"
    [nTooltipBeforeHide]="beforePanelHide"
    nTooltipOverlayClass="upgrade-overlay"
    [(nTooltipVisible)]="visible">
    <div *ngIf="!(currentProcess === 'precheckFailed' || currentProcess === 'upgradeFailed' || currentProcess === 'verifyFailed') && currentProcess !== 'verifySuc'">
        <svg class="icon">
            <use xlink:href="#app-icon-upgrade-ing"></use>
        </svg>
    </div>
    <div *ngIf="currentProcess === 'precheckFailed' || currentProcess === 'upgradeFailed' || currentProcess === 'verifyFailed'">
        <svg class="icon">
            <use xlink:href="#app-icon-upgrade-failed"></use>
        </svg>
    </div>
    <div *ngIf="currentProcess === 'verifySuc'">
        <svg class="icon">
            <use xlink:href="#app-icon-upgrade-suc"></use>
        </svg>
    </div>
</div>

<!-- 升级中面板 -->
<ng-template #alarmDropdown>
    <div class="upgrade-panel">
        <div class="upgrade-panel-title">
            <div class="upgrade-panel-title-name">
                {{i18n.hotPatchTitle}}
            </div>
            <div class="upgrade-panel-title-count" *ngIf="currentProcess !== 'verifySuc'">
                <ul>
                    <li *ngIf="str.ifShowTotal | fn :currentProcess">
                        <div class="upgrade-panel-title-count-all">{{checkDetails.length}}</div>
                        <div>{{i18n.total}}</div>
                    </li>
                    <li>
                        <div class="upgrade-panel-title-count-suc">{{sucCount || "0"}}</div>
                        <div>{{i18n.sucCount}}</div>
                    </li>
                    <li>
                        <div class="upgrade-panel-title-count-fail">{{failCount || "0"}}</div>
                        <div>{{i18n.failedCount}}</div>
                    </li>
                    <li>
                        <div class="upgrade-panel-title-count-ignore">0</div>
                        <div>{{i18n.ignoreCount}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="upgrade-panel-line"></div>
        <ng-container *ngIf="currentProcess !== 'verifySuc'">
            <!-- 多条提示信息 -->
            <n-lv>
                <n-lv-item [label]="i18n.circleDot">{{i18n.upgradeMsg1}}<span class="upgrade-panel-tip-warn">{{i18n.upgradeMsg2}}</span></n-lv-item>
                <n-lv-item [label]="i18n.circleDot">{{i18n.upgradeMsg3}}</n-lv-item>
                <n-lv-item [label]="i18n.circleDot">{{i18n.upgradeMsg4}}</n-lv-item>
            </n-lv>
            <div class="upgrade-panel-progress">
                <div class="upgrade-panel-progress-title">{{i18n.progress}}</div>
                <div style="display:inline-block;width:78%;">
                    <p-progressBar [value]="upgradeStatus.checkProgress" [showValue]="false" width="90%" [class.no-motion]="!progressMotion"></p-progressBar>
                </div>
                <div style="display:inline-block;margin-left: .07rem;">{{upgradeStatus.checkProgress}}%</div>
                <div class="upgrade-panel-progress-desc"
                    [ngStyle]="{'color': progressDesc[currentProcess]?.color}">
                    <svg class="icon"
                        [ngClass]="{'uploading': progressDesc[currentProcess]?.uploading}">
                        <use [attr.xlink:href]="'#icon-' + progressDesc[currentProcess]?.icon"/>
                    </svg>
                    {{progressDesc[currentProcess]?.text}}
                </div>
            </div>
            <!-- 升级前检查、升级后检查 -->
            <div class="upgrade-panel-detail" *ngIf="isCheck">
                <div *ngFor="let checkDetail of checkDetails;let i = index" class="upgrade-panel-detail-item">
                    <!-- 检查项 -->
                    <div class="upgrade-panel-detail-title">
                        <span class="upgrade-panel-detail-icon">
                            <svg class="icon" [ngClass]="{'uploading': +checkDetail.checkResult === CheckResult.Checking}">
                                <use [attr.xlink:href]="str.getSvg | fn :checkDetail.checkResult"/>
                            </svg>
                        </span>
                        {{str.getCheckItemValue | fn :checkDetail.checkItem}}
                    </div>
                    <!-- 查看详情 -->
                    <div *ngIf="checkDetail.nodeInfoArr"
                        class="upgrade-panel-detail-icon">
                        <div (click)="onShowCheckDetails(checkDetail?.checkItem)">
                            <!-- 失败的 -->
                            <ng-container *ngIf="str.isCheckResultFailed | fn :+checkDetail.checkResult; else common">
                                <span class="error-red">{{i18n.failDetail}}</span>
                            </ng-container>
                            <!-- 成功的 -->
                            <ng-template #common>
                                <span class="common-blue">{{i18n.detail}}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 升级、回滚中 -->
            <div class="upgrade-panel-detail" *ngIf="!isCheck">
                <div *ngFor="let checkDetail of checkDetails; let i = index" class="upgrade-panel-detail-item">
                    <div class="upgrade-panel-detail-content">
                        <span class="upgrade-panel-detail-content-time">{{checkDetail.checkItem}}</span>
                        <span class="upgrade-panel-detail-content-status" *ngIf="+checkDetail.checkResult === 0" style="color:#A0A4B1">
                            {{i18n.notInstall}}
                        </span>
                        <span class="upgrade-panel-detail-content-status" *ngIf="+checkDetail.checkResult === 1" style="color:#3DCCA6">
                            <svg class="icon uploading"><use xlink:href="#icon-loading"/></svg>
                            {{i18n.inStalling}}
                        </span>
                        <span class="upgrade-panel-detail-content-status" *ngIf="+checkDetail.checkResult === 2" style="color:#3DCCA6">
                            {{i18n.checkSuccessed}}
                        </span>
                        <span class="upgrade-panel-detail-content-status" *ngIf="+checkDetail.checkResult === 3" style="color:#FF4C4C">
                            {{i18n.checkFailed}}
                        </span>
                        <div class="view-details" (click)="onShowUpgradeDetails(i)" *ngIf="+checkDetail.checkResult ===3">
                            <svg class="icon" *ngIf="!checkDetail.showDetail"><use xlink:href="#icon-arrow-lg-right"/></svg>
                            <svg class="icon" *ngIf="checkDetail.showDetail"><use xlink:href="#icon-arrow-lg-top"/></svg>
                        </div>
                        <div style="content: '';clear:both;"></div>
                        <div style="width: 100%;background: #4a516c;padding: .1rem .16rem;color: #FF4C4C;margin: .1rem 0;" *ngIf="checkDetail.showDetail && +checkDetail.checkResult ===3">
                            {{checkDetail.nodeInfo}}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="upgrade-panel-operat" [ngClass]="{'active': btnEnabled}">
            <span *ngIf="currentProcess === 'precheckFailed'"
                (click)="onRetry()">
                <svg class="icon">
                    <use xlink:href="#icon-refresh"></use>
                </svg>
                <span class="upgrade-panel-operat-btn">{{i18n.reTry}}</span>
            </span>
            <span *ngIf="currentProcess !== Progress.verifySuc"
                (click)="onCancel()">
                <svg class="icon">
                    <use xlink:href="#icon-close"></use>
                </svg>
                <span class="upgrade-panel-operat-btn">{{i18n.cancle}}</span>
            </span>
        </div>
        <div class="upgrade-panel-successd" style="text-align:center;margin: .6rem auto;" *ngIf="currentProcess === 'verifySuc'">
            <div style="margin:.1rem 0;">
                <svg class="icon suc-icon">
                    <use xlink:href="#icon-status-succeed"></use>
                </svg>
            </div>
            <div style="margin:.1rem 0;">
                {{i18n.checkSuccessed}}
            </div>
            <div style="margin:.1rem 0;">
                {{i18n.currentVersion}} {{currentVersion}}
            </div>
            <button pButton
                type="button"
                (click)="onClose()"
                [label]="i18n.finishBtn">
            </button>
        </div>
    </div>
</ng-template>
